import { useNavigate, useLocation } from "react-router-dom";
import { requestLeaveConfirmation } from "../../library/UnsavedChangesGuard";
import '../../styles/main.css';
import testLogo from '../../assets/Test.png';
import birthdayLogo from '../../assets/module-icons/ic_birthday.png'
import mobileLogo from '../../assets/module-icons/ic_mobile.png'
import mailIntegrationsLogo from '../../assets/module-icons/ic_mailintegrations.png'
import googleLogo from '../../assets/module-icons/ic_google.png'
import facebookLogo from '../../assets/module-icons/ic_facebook.png'
import integrationsLogo from '../../assets/module-icons/ic_integrations.png'
import excelLogo from '../../assets/module-icons/ic_excel.png'
import usersLogo from '../../assets/module-icons/ic_users.png'
import licenceIcon from '../../assets/module-icons/ic_licence.png';
import shippingIcon from '../../assets/module-icons/ic_shipping.png';
import eticketLogo from '../../assets/module-icons/ic_eticket.png';
import inventoryLogo from '../../assets/mobile-icons/ic_inventory.png'
import settingLogo from '../../assets/mobile-icons/ic_settings.png'
import exactLogo from '../../assets/module-icons/ic_exact.png';
import geminiLogo from '../../assets/module-icons/ic_ai.png';
import webshopLogo            from '../../assets/module-icons/ic_webshop.png';
import webshopActionsLogo     from '../../assets/module-icons/ic_webshop_actions.png';
import webshopConfigLogo      from '../../assets/module-icons/ic_webshop_config.png';
import webshopConnectionsLogo from '../../assets/module-icons/ic_webshop_connections.png';
import webshopDataLogo        from '../../assets/module-icons/ic_webshop_data.png';
import rmaLogo from '../../assets/module-icons/ic_rma.png';
import schedulerLogo from '../../assets/module-icons/ic_scheduler.png';
import customerDisplayLogo from '../../assets/module-icons/ic_customer_display.png';
import peppolLogo from '../../assets/module-icons/ic_peppol.png';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartColumn } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@mui/material/Tooltip';

const SidebarItem = (props) => {  
    let navigate = useNavigate();
    const location = useLocation();
    
    // Check if current route matches this item's module
    const isActive = location.pathname.includes(`/${props.lang}/${props.data.module}`);
    
    let modIcon = inventoryLogo;
    let useFaIcon = null;
    switch(props.data.module){
        case 'ai':
            modIcon = geminiLogo;
            break;
        case 'mobile':
            modIcon = mobileLogo;
            break;
        case 'birthday':
            modIcon = birthdayLogo;
            break;
        case 'eticket':
            modIcon = eticketLogo;
            break;
        case 'exact':
            modIcon = exactLogo;    
            break;
        case 'excel':
            modIcon = excelLogo;
            break;
        case 'mail-integrations':
            modIcon = mailIntegrationsLogo;
            break;
        case 'integrations':
            modIcon = integrationsLogo;
            break;
        case 'google':
            modIcon = googleLogo;
            break;
        case 'facebook':
            modIcon = facebookLogo;
            break;
        case 'licence':
            modIcon = licenceIcon;
            break;
        case 'peppol':
            modIcon = peppolLogo;
            break;
        case 'reports':
            useFaIcon = faChartColumn;
            break;
        case 'rma':
            modIcon = rmaLogo;
            break;
        case 'scheduler':
            modIcon = schedulerLogo;
            break;
        case 'settings':
            modIcon = settingLogo;
            break;
        case 'shipping':
            modIcon = shippingIcon;
            break;
        case 'shipping-log':
            modIcon = shippingIcon;
            break;
        case 'users':
            modIcon = usersLogo;
            break;
        case 'customer-display':
            modIcon = customerDisplayLogo;
            break;
        case 'webshop':
            modIcon = webshopLogo;
            break;
        case 'webshop-actions':
            modIcon = webshopActionsLogo;
            break;
        case 'webshop-connections':
        case 'webshop-credentials':
            modIcon = webshopConnectionsLogo;
            break;
        case 'webshop-config':
        case 'webshop-accounts':
            modIcon = webshopConfigLogo;
            break;
        case 'webshop-data':
            modIcon = webshopDataLogo;
            break;
        default:
            modIcon = testLogo;
            break;
    }

    const clickHandler = async () => {
        // Don't silently discard buffered edits (webshop config/data screens
        // register themselves in the global unsaved-changes guard).
        if (!(await requestLeaveConfirmation())) return;
        props.toggleMobileOpen();
        return navigate("/"+props.lang+"/"+props.data.module);
    }

    // Use individual padding properties consistently instead of mixing with shorthand
    const baseStyle = {
        paddingTop: 3,
        paddingRight: 3,
        paddingBottom: 3,
        paddingLeft: 3
    };
    
    // Create styles for active state
    const activeStyle = {
        backgroundColor: props.theme === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.08)',
        borderRight: `4px solid ${props.theme === 'dark' ? '#90caf9' : '#1976d2'}`,
        paddingRight: 1, // Override just this one property
        position: 'relative'
    };

    // Compact mode: render only the icon, center it, and surface the module
    // name via a right-side Tooltip. Adjusts paddings so the row stays
    // square-ish and the active-state border still reads.
    if (props.compact) {
        const compactStyle = {
            paddingTop: 8,
            paddingRight: 8,
            paddingBottom: 8,
            paddingLeft: 8,
            justifyContent: 'center',
        };
        const compactActiveStyle = {
            backgroundColor: props.theme === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.08)',
            borderRight: `4px solid ${props.theme === 'dark' ? '#90caf9' : '#1976d2'}`,
            paddingRight: 4,
            position: 'relative',
        };
        return (
            <Tooltip title={props.title} placement="right" arrow>
                <ListItemButton
                    className={'sidebaritem_item_' + props.theme}
                    style={isActive ? { ...compactStyle, ...compactActiveStyle } : compactStyle}
                    onClick={() => clickHandler()}
                >
                    <ListItemIcon className={'sidebaritem_item__img '} sx={{ minWidth: 0, justifyContent: 'center' }}>
                        {useFaIcon
                            ? <FontAwesomeIcon
                                icon={useFaIcon}
                                style={{
                                    width: 22,
                                    height: 22,
                                    color: isActive
                                        ? (props.theme === 'dark' ? '#90caf9' : '#1976d2')
                                        : (props.theme === 'dark' ? '#ffffff' : '#444444')
                                }}
                              />
                            : <img
                                src={modIcon}
                                width="22px"
                                alt={props.data.module}
                                style={isActive ? { filter: props.theme === 'dark' ? 'brightness(1.2)' : 'none' } : {}}
                              />
                        }
                    </ListItemIcon>
                </ListItemButton>
            </Tooltip>
        );
    }

    return (
        <ListItemButton
            className={'sidebaritem_item_' + props.theme}
            style={isActive ? {...baseStyle, ...activeStyle} : baseStyle}
            onClick={()=>{clickHandler()}}
        >
            {<ListItemIcon className={'sidebaritem_item__img '}>
                {useFaIcon
                    ? <FontAwesomeIcon
                        icon={useFaIcon}
                        style={{
                            width: 22,
                            height: 22,
                            color: isActive
                                ? (props.theme === 'dark' ? '#90caf9' : '#1976d2')
                                : (props.theme === 'dark' ? '#ffffff' : '#444444')
                        }}
                      />
                    : <img
                        src={modIcon}
                        width="22px"
                        alt={props.data.module}
                        style={isActive ? { filter: props.theme === 'dark' ? 'brightness(1.2)' : 'none' } : {}}
                      />
                }
            </ListItemIcon>}
            <ListItemText
                className={'sidebaritem_item__title'}
                primary={props.title}
                primaryTypographyProps={{
                    style: isActive ? {
                        fontWeight: 'bold',
                        color: props.theme === 'dark' ? '#90caf9' : '#1976d2',
                        fontSize: '0.9em'
                    } : {
                        fontSize: '0.9em'
                    }
                }}
            />
        </ListItemButton>
    );
};

export default SidebarItem;